import { memo } from "react";

import { VehicleModelRow } from "services/api/catalog/vehicles/models/types";

interface VehicleModelTooltipProps {
  model: VehicleModelRow;
  /** Marka se ne nalazi na modelu, pa je prosljeđuje dropdown. */
  manufacturerName?: string | null;
}

const Row: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div className="flex justify-between text-sm mb-1">
    <span className="text-slate-300">{label}</span>
    <span className="font-medium text-right max-w-[180px] truncate">{value}</span>
  </div>
);

/**
 * Detalji modela na hover — slika i podaci koje redak popisa ne stigne pokazati.
 * Isti raspored kao tooltip ponude, da se dropdownovi ne razilaze.
 */
const VehicleModelTooltip: React.FC<VehicleModelTooltipProps> = ({
  model,
  manufacturerName,
}) => {
  const years =
    model.yearFrom && model.yearTo
      ? `${model.yearFrom} - ${model.yearTo}`
      : model.yearFrom
        ? `${model.yearFrom} -`
        : null;

  return (
    <div className="min-w-[260px]">
      {model.image && (
        <div className="mb-3 rounded overflow-hidden bg-white">
          <img
            src={model.image}
            alt={model.name}
            className="w-full h-[120px] object-contain"
          />
        </div>
      )}

      <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">
        Detalji modela
      </div>

      <Row label="Model" value={model.name} />
      {manufacturerName && <Row label="Marka" value={manufacturerName} />}
      {model.manufacturerCode && <Row label="Oznaka" value={model.manufacturerCode} />}
      {years && <Row label="Proizvodnja" value={years} />}
      {model.year != null && <Row label="Godina" value={model.year} />}
    </div>
  );
};

export default memo(VehicleModelTooltip);
